var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('gat-grid',{staticClass:"elevation-0",attrs:{"items":_vm.lines,"columns":_vm.columns,"dense":"","tight":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }